import React from 'react';
import { motion } from 'framer-motion';
import zappyImg from '../assets/zappy/zappy.png';
import quickbotImg from '../assets/quickbot/quickbot_2.png';

const zappyPlans = [
  {
    plan: 'Standard',
    price: '₹9,999/year',
    features: [
      '3,000 Max Contacts',
      'WhatsApp Broadcast',
      'Unlimited Messages',
      'Real Time Inbox',
      'Scheduled Campaigns',
      '2 Chatbot Flows',
      '2 Automations',
    ],
  },
  {
    plan: 'Pro',
    price: '₹14,999/year',
    features: [
      '10,000 Max Contacts',
      'WhatsApp Broadcast',
      'Unlimited Messages',
      'Real Time Inbox',
      'Scheduled Campaigns',
      '5 Chatbot Flows',
      '5 Automations',
    ],
  },
  {
    plan: 'Professional',
    price: '₹19,999/year',
    features: [
      '25,000 Max Contacts',
      'WhatsApp Broadcast',
      'Unlimited Messages',
      'Real Time Inbox',
      'Scheduled Campaigns',
      '10 Chatbot Flows',
      '10 Automations',
    ],
  },
];



const quickbotPlans = [
  {
    plan: 'Standard',
    price: '₹7,999/year',
    features: [
      '100 Web pages',
      '1 Website',
      '200 Chat Messages / Month',
      '100K Characters (Free above with your own OpenAI key)',
      'Website Chatbot Flow',
      'Chat Inbox',
    ],
  },
  {
    plan: 'Pro',
    price: '₹14,999/year',
    features: [
      '300 Web pages',
      '2 Websites',
      '5,000 Chat Messages / Month',
      '300K Characters (Free above with your own OpenAI key)',
      'Website Chatbot Flow',
      'Chat Inbox',
    ],
  },
  {
    plan: 'Professional',
    price: '₹24,999/year',
    features: [
      '1000 Web pages',
      '5 Websites',
      'Unlimited Chat Messages',
      '1 Million Characters (Free above with your own OpenAI key)',
      'Website Chatbot Flow',
      'Chat Inbox',
    ],
  },
];



const Pricing = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-6xl mx-auto px-6 py-16"
    >
      <h1 className="text-4xl font-bold text-center text-blue-700 mb-12">
        Our Products
      </h1>

      <div className="bg-blue-100 rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col items-center text-center">
        <img src={zappyImg} alt="Zappy" className="h-30 w-60 object-contain mb-1" />
        {/* <h2 className="text-3xl font-bold text-gray-800 mb-1">Zappy</h2> */}
        <p className="text-indigo-600 font-medium text-base mb-6">
          WhatsApp Marketing Made Easy
        </p>

        <div className="w-full grid md:grid-cols-3 gap-6 mt-4">
        {zappyPlans.map(({ plan, price, features }, idx) => (
            <div
            key={idx}
            className="bg-white rounded-xl p-6 text-left shadow-inner flex flex-col items-center"
            >
            <h3 className="text-2xl font-bold text-blue-700 mb-2 text-center">{plan}</h3>
            <p className="text-2xl text-green-600 font-bold mb-6 text-center">{price}</p>
            <ul className="space-y-2 text-sm text-gray-700 w-full">
                {features.map((feature, i) => (
                <li key={i} className="flex items-start">
                    <span className="h-2 w-2 mt-2 bg-blue-500 rounded-full mr-3" />
                    {feature}
                </li>
                ))}
            </ul>
            </div>
        ))}
        </div>


        <a
          href="https://zappy.mymarketingbuddy.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 inline-block px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition"
        >
          Get Started with Zappy
        </a>
      </div>

      {/* QuickBot Pricing Section */}
    <div className="bg-blue-100 rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col items-center text-center mt-16">
    <img src={quickbotImg} alt="QuickBot" className="h-30 w-60 object-contain mb-1" />
    <p className="text-indigo-600 font-medium text-base mb-6">
        Chatbot Automation for WhatsApp
    </p>

    <div className="w-full grid md:grid-cols-3 gap-6 mt-4">
        {quickbotPlans.map(({ plan, price, features }, idx) => (
        <div
            key={idx}
            className="bg-white rounded-xl p-6 text-left shadow-inner flex flex-col items-center"
        >
            <h3 className="text-2xl font-bold text-blue-700 mb-2 text-center">{plan}</h3>
            <p className="text-2xl text-green-600 font-bold mb-6 text-center">{price}</p>
            <ul className="space-y-2 text-sm text-gray-700 w-full">
            {features.map((feature, i) => (
                <li key={i} className="flex items-start">
                <span className="h-2 w-2 mt-2 bg-blue-500 rounded-full mr-3" />
                {feature}
                </li>
            ))}
            </ul>
        </div>
        ))}
    </div>

    <a
        href="https://quickbot.mymarketingbuddy.com"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-8 inline-block px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition"
    >
        Get Started with QuickBot
    </a>
    </div>

    </motion.section>
  );
};

export default Pricing;
